import React, { useEffect } from 'react';
import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { useForm } from 'react-hook-form';
import { GridForm } from 'components/Ui/styled';
import { getDialogHeading } from 'utils/commonUtils';
import { PaperPropsWithoutScrollbar } from 'constants';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import { capitalizeFirstLetter } from './ViewBookedSessionsTabV2Utils';

const BookedSessionInfoV2Dialog = ({
  open,
  setOpen,
  bookedSessionInfo = {},
}) => {
  const {
    date,
    reason,
    status,
    dayOfWeek,
    studentId,
    endTimeFmt,
    subjectName,
    startTimeFmt,
    studentLastName,
    studentFirstName,
    studentGradeLevel,
    assignedTutorName,
  } = bookedSessionInfo;

  const getDefaultValues = () => ({
    date: date || '',
    reason: reason || '',
    studentId: studentId || '',
    studentGradeLevel: studentGradeLevel || '',
    status: capitalizeFirstLetter(status) || '',
    dayOfWeek: capitalizeFirstLetter(dayOfWeek),
    subjectName: capitalizeFirstLetter(subjectName),
    assignedTutorName: capitalizeFirstLetter(assignedTutorName),
    time: startTimeFmt && endTimeFmt ? `${startTimeFmt} - ${endTimeFmt}` : '',
    student:
      `${capitalizeFirstLetter(studentFirstName)} ${capitalizeFirstLetter(studentLastName)}`.trim(),
  });

  const defaultValues = getDefaultValues();

  const { reset, control } = useForm({
    defaultValues,
    mode: 'onChange',
  });

  useEffect(() => {
    if (open) reset(defaultValues);
  }, [open, defaultValues, reset]);

  const handleClose = () => setOpen(false);

  const fields = [
    { name: 'date', label: 'Date' },
    { name: 'time', label: 'Time' },
    { name: 'dayOfWeek', label: 'Day' },
    { name: 'student', label: 'Student' },
    { name: 'studentGradeLevel', label: 'Grade' },
    { name: 'studentId', label: 'Student ID' },
    { name: 'subjectName', label: 'Subject' },
    { name: 'assignedTutorName', label: 'Tutor' },
    { name: 'reason', label: 'Reason' },
    { name: 'status', label: 'Status' },
  ];

  return (
    <Dialog open={open} PaperProps={PaperPropsWithoutScrollbar}>
      {getDialogHeading('Session Details', handleClose)}

      <GridForm container spacing={1}>
        {fields.map(({ name, label }) => (
          <Grid item xs={12} sm={6} key={name}>
            <FormInputText
              readOnly
              name={name}
              label={label}
              control={control}
            />
          </Grid>
        ))}
      </GridForm>

      <MDBox mb={3} />
    </Dialog>
  );
};

export default BookedSessionInfoV2Dialog;
